import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import FormElementWrapper from "./FormElementWrapper";

const inputIcon = {
    text: "icon-eye-slash",
    password: "icon-eye",
};

class Input extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasToggleIcon: props.type === "password" && props.hasPasswordViewPermission,
            type: props.type || "text",
            value: props.value || props.defaultValue || (props.input && props.input.value) || "",
            cursorPosition: null,
            wasFocused: false,
        };
        this.input = React.createRef();
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const { hasPasswordViewPermission: hasToggleIcon } = nextProps;
        let data = null;

        if (nextProps.input && prevState.value !== nextProps.input.value) {
            data = { ...data, value: nextProps.input.value };
        }
        if (hasToggleIcon !== prevState.hasToggleIcon) {
            data = { ...data, hasToggleIcon };
        }

        return data;
    }

    componentDidUpdate() {
        if (this.input && this.input.current) {
            const { cursorPosition } = this.state;
            if (cursorPosition !== null) {
                this.input.current.setSelectionRange(cursorPosition, cursorPosition);
            }
        }
    }

    getInputIcons = () => {
        if (!this.state.value) return null;
        const icons = [this.getResetIcon(), this.getPasswordToggle()].filter(item => !!item);
        if (!icons.length) return null;

        return <div className={`input-field-icons icons-count-${icons.length}`}>{icons.map(item => item)}</div>;
    };

    getPasswordToggle = () => {
        const { hasToggleIcon, type } = this.state;
        const icon = (
            <i key="icon-password" onClick={this.toggleInputType} className={`input-field-icon ${inputIcon[type]}`} />
        );

        return hasToggleIcon ? icon : null;
    };

    getResetIcon = () => {
        const clear = <i key="icon-clear" onClick={this.clearValue} className="icon-close" />;
        return this.props.clearable ? clear : null;
    };

    toggleInputType = ev => {
        ev.preventDefault();
        this.setState({ type: this.state.type === "password" ? "text" : "password" });
    };

    clearValue = () => {
        this.setState({ value: "", cursorPosition: 0 });
        const { input, onChange } = this.props;
        if (input && input.onBlur) input.onBlur(null);
        if (onChange) onChange("");
    };

    handleChange = ev => {
        const { value } = ev.target;
        this.setState({ value, cursorPosition: this.input.current.selectionStart });
        const { input, onChange } = this.props;
        if (input && input.onChange) input.onChange(value);
        if (onChange) onChange(value);
    };

    onFocus = ev => {
        this.state.wasFocused = true;
    };

    render() {
        const { hasPasswordViewPermission, clearable, defaultValue, label, input, meta, ...restProps } = this.props;
        const { value, type } = this.state;
        return (
            <FormElementWrapper meta={meta} label={label} required={restProps.required}>
                <div className={cx("input-field-wrap", { "not-empty": value, "was-focused": this.state.wasFocused })}>
                    {this.getInputIcons()}
                    <input
                        className="input-field"
                        {...input}
                        {...restProps}
                        value={value}
                        ref={this.input}
                        type={type}
                        onBlur={e => this.props.input && this.props.input.onBlur && this.props.input.onBlur(undefined)}
                        onFocus={e => this.props.input && this.onFocus(undefined)}
                        onChange={this.handleChange}
                    />
                </div>
            </FormElementWrapper>
        );
    }
}

Input.displayName = "Input";

Input.propTypes = {
    hasPasswordViewPermission: PropTypes.bool,
    clearable: PropTypes.bool,
    required: PropTypes.bool,
};

Input.defaultProps = {
    hasPasswordViewPermission: false,
    clearable: false,
    required: false,
};

export default Input;
